module.exports = __webpack_public_path__ + "img/9.7568675a.svg";